import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../services/supabaseService';
import { getOrganizationQuery } from '../utils/domainDetection';

const OrganizationContext = createContext(null);

export const OrganizationProvider = ({ children }) => {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadOrganization();
  }, []);

  const loadOrganization = async () => {
    try {
      setLoading(true);
      setError(null);

      // Get query parameters based on domain
      const query = getOrganizationQuery();
      
      console.log('Loading organization with query:', query);

      // Fetch organization from Supabase
      const { data, error: fetchError } = await supabase
        .from('organizations')
        .select('*')
        .eq(query.field, query.value)
        .eq('is_active', true)
        .single();

      if (fetchError) {
        console.error('Error fetching organization:', fetchError);
        setError('Organization not found');
        setLoading(false);
        return;
      }

      if (!data) {
        console.error('No organization found for domain');
        setError('Organization not found');
        setLoading(false);
        return;
      }

      console.log('Organization loaded:', data);
      setOrganization(data);
      setLoading(false);
    } catch (err) {
      console.error('Error loading organization:', err);
      setError('Failed to load organization');
      setLoading(false);
    }
  };

  const value = {
    organization,
    loading,
    error,
    reload: loadOrganization
  };

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
};

export default OrganizationContext;
